import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { initialState } from "./initialState";
import { searchByQuery } from "./search.thunk";
import { AxiosError } from "axios";
import { PRODUCTS_PER_PAGE } from "../../constants/search";
import { INTERNAL_SERVER_ERROR, NO_SEARCH_RESULTS } from "../../constants";

const searchSlice = createSlice({
  name: "search",
  initialState,
  reducers: {
    resetSearchState: (state) => {
      state.products = [];
      state.displayCount = PRODUCTS_PER_PAGE;
      state.error = null;
      state.isLoading = false;
      state.lastSearchQuery = null;
    },
    loadMore: (state) => {
      state.displayCount += PRODUCTS_PER_PAGE;
    },
    setError: (state, action: PayloadAction<string>) => {
      state.error = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(searchByQuery.pending, (state, action) => {
        state.isLoading = true;
        state.error = null;
        state.lastSearchQuery = action.meta.arg.q;
      })
      .addCase(searchByQuery.fulfilled, (state, action) => {
        state.products = action.payload;
        state.displayCount = PRODUCTS_PER_PAGE;
        state.isLoading = false;
        state.error = action.payload.length ? null : NO_SEARCH_RESULTS;
      })
      .addCase(searchByQuery.rejected, (state, action) => {
        state.isLoading = false;
        if (action.payload instanceof AxiosError) {
          state.error = action.payload.message;
        } else {
          state.error = INTERNAL_SERVER_ERROR;
        }
      });
  },
});

export const { resetSearchState, setError, loadMore } = searchSlice.actions;

export default searchSlice.reducer;
